import EFP_Logo from 'assets/images/intro/EFP_logo.png';
import { IS_EFP } from 'config';

const showLogo = IS_EFP;

const FooterLogoIcon = () => {
    return showLogo && <img src={EFP_Logo} alt='EFP Workflows' width='20' />;
};

export default FooterLogoIcon;
